import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import {AuthService} from '../authentication/auth.service';
import {uriConsts} from "@shared/constants";
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class LogginedGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isLoginEd()) {
      if (isPlatformBrowser(this.platformId)) {
        window.location.href = uriConsts.admin;
      } else {
        this.router.navigateByUrl(uriConsts.admin);
      }
      return false;
    }
    return true;
  }
}
